module.exports = __webpack_public_path__ + "ee3cf4a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon_twitter.png
// module id = 1813
// module chunks = 0